import { MaterialConfiguration } from './material-configuration';
import { TranslateHandlebarsPipe } from 'app/shared/pipes/translate-handlebars.pipe';
import { LinkActions } from '../../common/base-card-configuration';

export class ExternalArticleConfiguration extends MaterialConfiguration {
    constructor(course: any, translateHandlebarsPipe: TranslateHandlebarsPipe) {
        super();
        this.tagType = 'externalLink';
        this.thumbnail = course.smallImageUri || 'https://itpx-branded-portal-dev.s3.amazonaws.com/ebook.png';
        this.classType = 'Article';
        this.multiContent = course.contents.length > 1;
        this.subtitle = 'branded.portal.courses.assignment.material.external-article.subtitle';
        this.expired = !course.enabled;
        this.clickable = !this.expired;
        this.action = LinkActions.SSO;
        this.links = [{
            disabled: this.expired,
            tooltip: this.expired ? 'branded.portal.courses.assignment.external-article.launch.tooltip' : null,
            url: this.expired ? '' : course.path,
            text: 'branded.portal.courses.assignment.external-article.launch.text',
            type: LinkActions.SSO
        }];
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/configurations/external-article-configuration.ts